import api from '../api/axios';

export const finanzasService = {
  getFinanzas: async () => {
    const { data } = await api.get('/transactions');
    return Array.isArray(data) ? data : [];
  },

  crearFinanza: async (datos) => {
    const { data } = await api.post('/transactions', datos);
    return data;
  },

  eliminarFinanza: async (id) => {
    const { data } = await api.delete(`/transactions/${id}`);
    return data;
  },

  getMetas: async () => {
    const { data } = await api.get('/metas');
    return Array.isArray(data) ? data : [];
  },

  crearMeta: async (datos) => {
    const { data } = await api.post('/metas', datos);
    return data;
  },

  actualizarMeta: async ({ id, datos }) => {
    const { data } = await api.put(`/metas/${id}`, datos);
    return data;
  },

  eliminarMeta: async (id) => {
    const { data } = await api.delete(`/metas/${id}`);
    return data;
  }
};
